import { render } from "./allKitchenBills.vue?vue&type=template&id=2c92e4b6&scoped=true"
import script from "./allKitchenBills.vue?vue&type=script&lang=js"
export * from "./allKitchenBills.vue?vue&type=script&lang=js"

import "./allKitchenBills.vue?vue&type=style&index=0&id=2c92e4b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c92e4b6"]])

export default __exports__